
import React from 'react';
import PropTypes from 'prop-types';

import Button from 'src/component/UI/Button';

import QRCode from 'react-qr-code';
import { useTranslation } from 'src/i18n';

export default function TOTPQRCode (props) {
  const {
    continueButton,
    OTP_URL,
    secret
  } = props;
  const { t } = useTranslation();
  return (
    <>
      <h3>{t('auth.totp.setupMfa')}</h3>
      <div>{t('auth.totp.scanQr')}</div>
      <div className="qrcode"><QRCode value={OTP_URL} /></div>
      <div>
        {t('auth.totp.orEnterCode')}
      </div>
      <i className='secret'>{secret}</i>

      <div className='otpButton'>
        <Button cta type='submit' onClick={continueButton}>{t('auth.totp.continue')}</Button>
      </div>
    </>
  );
}

TOTPQRCode.propTypes = {
  continueButton: PropTypes.func.isRequired,
  OTP_URL: PropTypes.string.isRequired,
  secret: PropTypes.string.isRequired
};

TOTPQRCode.defaultProps = {
};
